import { TaggedError } from "../tagged-error.js";
export class NotFoundError extends TaggedError {
    constructor() {
        super("NotFoundError");
    }
}
